import { settleApiCall } from '../api/utils';
import { convertDisplayedPriceVariantsToPriceVariantsDTO } from '../utils/converters';
import { cleanDoubleAndTrailingSpace } from '../utils/modifiers';
import { categorizeByExistence, filterOutDuplicatedNames } from './utils/common';
import { createFieldToEntityMap } from '../utils/common';
export const createPriceVariants = async (priceVariants, priceVariantsClient) => {
  const priceVariantsInDTOForm = convertDisplayedPriceVariantsToPriceVariantsDTO(priceVariants);
  const existingPriceVariantsQuery = {
    filter: {
      name: {
        $in: priceVariantsInDTOForm.map(priceVariant => priceVariant.name)
      }
    }
  };
  const getExistingPriceVariantsResponse = await settleApiCall(() => priceVariantsClient.query(existingPriceVariantsQuery));
  if (getExistingPriceVariantsResponse.hasError) {
    return getExistingPriceVariantsResponse;
  }
  const existingPriceVariantsMap = createFieldToEntityMap(getExistingPriceVariantsResponse.data.data, 'name');
  const {
    newEntities: newPriceVariants,
    existingEntities: existingPriceVariants
  } = categorizeByExistence(priceVariantsInDTOForm, existingPriceVariantsMap);
  const newPriceVariantsWithoutDuplicates = filterOutDuplicatedNames(newPriceVariants);
  const newPriceVariantsForCreation = newPriceVariantsWithoutDuplicates.map(priceVariant => ({
    name: priceVariant.name
  }));
  const createPriceVariantsResponse = newPriceVariantsForCreation.length > 0 ? await settleApiCall(() => priceVariantsClient.bulkCreate(newPriceVariantsForCreation)) : undefined;
  if (createPriceVariantsResponse != null && createPriceVariantsResponse.hasError) {
    return createPriceVariantsResponse;
  }
  const allPriceVariants = [...((createPriceVariantsResponse == null ? void 0 : createPriceVariantsResponse.data) || []), ...(existingPriceVariants || [])];
  const namesToPriceVariantsMap = createFieldToEntityMap(allPriceVariants, 'name');
  const priceVariantsWithIds = priceVariants.map(priceVariant => {
    const priceVariantName = cleanDoubleAndTrailingSpace(priceVariant.name);
    const createdPriceVariant = namesToPriceVariantsMap[priceVariantName];
    return {
      name: createdPriceVariant.name,
      priceInfo: priceVariant.priceInfo,
      id: createdPriceVariant.id,
      revision: createdPriceVariant.revision,
      businessLocationIds: createdPriceVariant.businessLocationIds ?? []
    };
  });
  return {
    data: priceVariantsWithIds,
    hasError: false
  };
};
//# sourceMappingURL=createPriceVariants.js.map